module.exports = __webpack_public_path__ + "resources/img/img_zenius_logmanager_1_en.5edc84088b111147433d4bbad300b483.png";